import { Injectable, inject } from '@angular/core';

import { CoreActions } from '@next/core-lib';
import { UserActions } from '@next/core-lib/user';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, map, startWith, finalize } from 'rxjs/operators';

import * as CropAidActions from './crop-aid.actions';
import { SiteState } from '../../shared/models';
import { UnitOfMeasurementEnum } from '../crop-aid.model';
import { CropAidApiService } from '../services/crop-aid-api.service';

@Injectable()
export class CropAidEffects {
  protected readonly store = inject<Store<SiteState>>(Store);
  protected readonly actions$ = inject(Actions);
  protected readonly cropAidapi = inject(CropAidApiService);

  userInitialized$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.userInitialized),
      map(() => CropAidActions.getCropAids()),
    ),
  );

  getCropAids$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CropAidActions.getCropAids),
      switchMap((_) =>
        this.cropAidapi.getCropAids().pipe(
          map((cropAids) => {
            const mapped = cropAids.map((cropAid) => ({
              ...cropAid,
              /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
              unitOfMeasurement: (UnitOfMeasurementEnum as any)[cropAid.unitOfMeasurement],
            }));
            return CropAidActions.setCropAids({ cropAids: mapped });
          }),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
        ),
      ),
    ),
  );
}
